import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../utils/api";
import { useUser } from "../../../../utils/hooks/user";
import { useCompany } from "../../../../utils/hooks/company";

export const preferenceQueryKeys = {
    user: (userId: string) => [`/preferencies/user/${userId}`] as const,
    company: (companyId: string) => [`/preferencies/company/${companyId}`] as const,
};

export const userPreferenceQueryOptions = (authGet: (url: string) => Promise<any>, userId?: string) => ({
    queryKey: preferenceQueryKeys.user(userId as string),
    queryFn: () => authGet(`/preferencies/user/${userId}`),
    enabled: !!userId,
    staleTime: Infinity,
});

export const companyPreferenceQueryOptions = (authGet: (url: string) => Promise<any>, companyId?: string) => ({
    queryKey: preferenceQueryKeys.company(companyId as string),
    queryFn: () => authGet(`/preferencies/company/${companyId}`),
    enabled: !!companyId,
    staleTime: Infinity,
});

export const usePreferenceQuery = (userId?: string) => {
    const user = useUser();
    const company = useCompany();

    const { authGet } = useApi();

    const effectiveUserId = userId ?? user?.id;

    const userQuery = useQuery(userPreferenceQueryOptions(authGet, effectiveUserId));

    const companyQuery = useQuery(companyPreferenceQueryOptions(authGet, company?.id));

    const userData = userQuery.data?.result || [];
    const companyData = companyQuery.data?.result || [];

    return {
        userData,
        companyData,
        isLoading: userQuery.isLoading || companyQuery.isLoading,
    };
}
